module.exports = __webpack_public_path__ + "b488e899178d27401615dab86b8dd4ed.png";